// extracted by mini-css-extract-plugin
export default {"wrapper":"CD-z","viewport":"DD-z","container":"ED-z","slide":"FD-z"};